import React from "react";
import './Loading.css';

class Loading extends React.Component<any> { 
    render() {
        return (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
               
                    <div className="tempoe-spinner"></div>   
                
                      
               {/* <img src={require('../assets/img/conns-spinner.gif')} className="w-20" />*/}
            </div>
        )
    }
}

export default Loading